<template>
  <footer class="footer">
    <div class="footer-body">
      <div class="footer-logo">
        <a
          :href="siteConfig.logoUrl == '' ? '/' : siteConfig.logoUrl"
          v-show="siteConfig.logo"
        >
          <img :src="concatImageUrl(siteConfig.logo)" />
        </a>
      </div>
      <div
        class="footer-info"
        :style="
          siteConfig.agencyId == 4089
            ? 'text-align: center; margin-left: 30px;'
            : ''
        "
      >
        <template v-if="siteConfig.footerTel && isContact">咨询热线：{{ siteConfig.footerTel }}</template>
        <template v-if="siteConfig.footerQQ && isContact">
          | QQ：{{ siteConfig.footerQQ }}</template>
        <template v-if="siteConfig.companyName">
          | 版权所有 © {{ siteConfig.companyName }}</template>
        <template v-if="siteConfig.agencyId == 4089">
          <br />地址：{{ addressList[0] }} <br />工业和信息化部备案号：
          <a
            href="https://beian.miit.gov.cn"
            target="_blank"
          >{{siteConfig.icpNumber}}</a>
          <a
            v-show="siteConfig.networkRecord"
            :href="
              'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=' +
              networkEndNo
            "
            target="_blank"
          >
            <img
              alt="公安备"
              src="../../assets/images/sec.png"
              align="middle"
            />
            {{ networkStartArea }}公网安备{{ networkEndNo }}号
          </a>
          <a
            v-show="siteConfig.certificate"
            :href="concatImageUrl(siteConfig.certificate)"
            target="_blank"
          >
            <img
              alt="营业执照"
              src="../../assets/images/certificate.png"
              align="middle"
            />
            营业执照
          </a>
        </template>
        <template v-else>
          <br />工业和信息化部备案号：
          <a
            href="https://beian.miit.gov.cn"
            target="_blank"
          >{{siteConfig.icpNumber}}</a>
          <a
            v-show="siteConfig.networkRecord"
            :href="
              'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=' +
              networkEndNo
            "
            target="_blank"
          >
            <img
              alt="公安备"
              src="../../assets/images/sec.png"
              align="middle"
            />
            {{ networkStartArea }}公网安备{{ networkEndNo }}号
          </a>
          <a
            v-show="siteConfig.certificate"
            :href="concatImageUrl(siteConfig.certificate)"
            target="_blank"
          >
            <img
              alt="营业执照"
              src="../../assets/images/certificate.png"
              align="middle"
            />
            营业执照
          </a>
          <div
            class="footer-address"
            v-show="siteConfig.footerAdr"
          >
            <address>地址：</address>
            <p
              v-for="(item, index) in addressList"
              :key="index"
            >{{ item }}</p>
          </div>
        </template>
      </div>
      <div
        v-if="siteConfig.agencyId === 4089"
        style="position: absolute; right: 0px; top: 8px"
      >
        <div style="display: inline-block; vertical-align: top">
          <img
            v-if="siteConfig.sidebarQRCode"
            :src="concatImageUrl(siteConfig.sidebarQRCode)"
            alt="扫一扫"
            width="100"
            height="100"
          />
        </div>
        <div style="display: inline-block; margin-left: 50px">
          <template v-if="!isCustomApp">
            <img
              src="../../assets/images/app-qrcode.png"
              width="100"
              height="100"
              alt="qrcode"
            />
          </template>
          <template v-else>
            <vue-qr
              :margin="5"
              :size="100"
              :correctLevel="3"
              :text="appQrcodeData.url"
              :logoSrc="appQrcodeData.icon"
              :logoMargin="5"
              style="display: block"
            ></vue-qr>
          </template>
        </div>
      </div>
    </div>
    <app-siderbar></app-siderbar>
  </footer>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import AppSiderbar from "./AppSiderbar";
import VueQr from "vue-qr";
export default {
  mixins: [siteMixin],
  components: {
    AppSiderbar,
    VueQr,
  },
  data () {
    return {
      networkStartArea: "粤",
      networkEndNo: "44011202000208",
      isCustomApp: false,
      isContact:true
    };
  },
  computed: {
    addressList () {
      if (!this.siteConfig.footerAdr) return [];
      return this.siteConfig.footerAdr.split(/\$\$/);
    },
  },
  mounted () {
    // 当前agencyId为0  并且域名不是本公司其下域名，则隐藏
    const hostname = window.location.hostname;
    if (this.siteConfig.agencyId === 0 && hostname !== process.env.VUE_APP_WEB_DOMAIN ) {
      this.isContact = false
    }
    this.networkRecordSplit();
    this.setQrCode();
  },
  methods: {
    networkRecordSplit () {
      if (this.siteConfig.agencyId === 0) return;
      if (!this.siteConfig.networkRecord) return;
      this.networkStartArea = this.siteConfig.networkRecord.substring(0, 1);
      this.networkEndNo = this.siteConfig.networkRecord.substring(1);
    },
    setQrCode () {
      if (
        this.siteConfig.agencyId > 0 &&
        this.siteConfig.appDownAndroid &&
        this.siteConfig.appDownApple &&
        this.siteConfig.qrCodeLogo
      ) {
        this.isCustomApp = true;
        this.appQrcodeData = {
          url: window.location.protocol + "//" + document.domain + "/app",
          icon: this.concatImageUrl(this.siteConfig.qrCodeLogo),
        };
      }
    },
  },
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  background: #fff;
  color: #333;

  .footer-body {
    position: relative;
    width: 1200px;
    padding: 20px 0;
    margin: 0 auto;
    .footer-logo {
      display: inline-block;
      height: 50px;
      max-width: 250px;
      overflow: hidden;
      margin-right: 50px;
      vertical-align: middle;

      img {
        height: 50px;
        display: block;
      }
    }

    .footer-info {
      display: inline-block;
      vertical-align: middle;
      line-height: 25px;

      a {
        color: #333;
        margin-right: 1rem;
        color: #333;
        img {
          display: inline-block;
          vertical-align: middle;
        }
      }
      .footer-address {
        position: relative;
        address {
          position: absolute;
          font-style: normal;
        }
        p {
          margin-left: 40px;
        }
      }
    }
  }
}
</style>
